import React from "react";
import { Alert, Snackbar } from "@mui/material";

const SupplierToast = ({ toast, onClose }) => (
    <Snackbar
        open={toast.open}
        autoHideDuration={4000}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
        <Alert severity={toast.severity} onClose={onClose} variant="filled" sx={{ borderRadius: 2 }}>
            {toast.msg}
        </Alert>
    </Snackbar>
);

export default SupplierToast;
